import { createStore, combineReducers, applyMiddleware} from 'redux'
import { thunk }  from 'redux-thunk'

import { 
    userLoginReducer, userRegisterReducer, userDetailsReducer, 
    userListReducer, userDeleteReducer, userUpdateReducer,
    userUpdateProfileReducer, profileImageUploadReducer,
    userRolesReducer, userRolesUpdateReducer,
} from './reducers/userReducers'

import {
    blogListReducer, blogMineReducer, blogDetailsReducer,
    blogCreateReducer, blogUpdateReducer, blogDeleteReducer,
} from './reducers/blogReducers'

import { rssArticlesReducer, rssFeedsListReducer, rssFeedCreateReducer, rssFeedUpdateReducer, rssFeedDeleteReducer } from './reducers/rssReducers'
import { leaderboardReducer, liveScoresReducer } from './reducers/leaderboardReducers'
import { homeHeroReducer } from './reducers/homeReducers'
import {
    leagueListReducer, leagueDetailsReducer, leagueActiveReducer,
    leagueCreateReducer, leagueUpdateReducer, leagueDeleteReducer,
    leagueRegisterPlayerReducer, leagueRemovePlayerReducer,
    leagueGenerateScheduleReducer,
    leagueMatchupUpdateReducer, leagueMatchupLockReducer,
    leagueScoresReducer, leagueSaveScoreReducer,
} from './reducers/leagueReducers'

import {
    paymentTypeListReducer, paymentTypeDetailsReducer,
    paymentTypeCreateReducer, paymentTypeUpdateReducer, paymentTypeDeleteReducer,
    userPaymentMethodListReducer, userPaymentMethodAddReducer, userPaymentMethodDeleteReducer,
} from './reducers/paymentReducers'

import {
    awardListReducer, awardDetailsReducer,
    awardCreateReducer, awardUpdateReducer, awardDeleteReducer,
} from './reducers/awardReducers'

import {
    contestListReducer, contestDetailsReducer,
    contestCreateReducer, contestUpdateReducer, contestDeleteReducer,
} from './reducers/contestReducers'

import {
    courseListReducer, courseDetailsReducer,
    courseCreateReducer, courseUpdateReducer, courseDeleteReducer,
} from './reducers/courseReducers'

import {
    holeCreateReducer, holeUpdateReducer, holeDeleteReducer,
} from './reducers/holeReducers'

import {
    tournamentListReducer, tournamentDetailsReducer,
    tournamentCreateReducer, tournamentUpdateReducer, tournamentDeleteReducer,
    tournamentDayCreateReducer, tournamentDayUpdateReducer, tournamentDayDeleteReducer,
    tournamentAwardCreateReducer, tournamentAwardDeleteReducer,
    tournamentContestCreateReducer, tournamentContestDeleteReducer,
    tournamentRegListReducer, tournamentRegAddReducer, tournamentRegUpdateReducer, tournamentRegDeleteReducer,
    tournamentTeamsListReducer, tournamentTeamsGenerateReducer, tournamentTeamsClearReducer,
    tournamentTeamAddReducer,
    tournamentTeamMemberAddReducer, tournamentTeamMemberRemoveReducer,
    tournamentAwardUpdateReducer, tournamentContestUpdateReducer, tournamentWinnerUpdateReducer,
} from './reducers/tournamentReducers'

const reducer = combineReducers({
    userLogin: userLoginReducer,
    userRegister: userRegisterReducer,
    userDetails: userDetailsReducer,
    userUpdate: userUpdateReducer,
    userList: userListReducer,
    userDelete: userDeleteReducer,
    userUpdateProfile: userUpdateProfileReducer,
    profileImageUpload: profileImageUploadReducer,
    userRoles: userRolesReducer,
    userRolesUpdate: userRolesUpdateReducer,

    blogList:    blogListReducer,
    blogMine:    blogMineReducer,
    blogDetails: blogDetailsReducer,
    blogCreate:  blogCreateReducer,
    blogUpdate:  blogUpdateReducer,
    blogDelete:  blogDeleteReducer,

    rssArticles:  rssArticlesReducer,
    rssFeedsList: rssFeedsListReducer,
    rssFeedCreate: rssFeedCreateReducer,
    rssFeedUpdate: rssFeedUpdateReducer,
    rssFeedDelete: rssFeedDeleteReducer,
    leaderboard:  leaderboardReducer,
    liveScores:   liveScoresReducer,
    homeHero:     homeHeroReducer,

    paymentTypeList: paymentTypeListReducer,
    paymentTypeDetails: paymentTypeDetailsReducer,
    paymentTypeCreate: paymentTypeCreateReducer,
    paymentTypeUpdate: paymentTypeUpdateReducer,
    paymentTypeDelete: paymentTypeDeleteReducer,
    userPaymentMethodList:   userPaymentMethodListReducer,
    userPaymentMethodAdd:    userPaymentMethodAddReducer,
    userPaymentMethodDelete: userPaymentMethodDeleteReducer,

    awardList: awardListReducer,
    awardDetails: awardDetailsReducer,
    awardCreate: awardCreateReducer,
    awardUpdate: awardUpdateReducer,
    awardDelete: awardDeleteReducer,

    contestList: contestListReducer,
    contestDetails: contestDetailsReducer,
    contestCreate: contestCreateReducer,
    contestUpdate: contestUpdateReducer,
    contestDelete: contestDeleteReducer,

    courseList: courseListReducer,
    courseDetails: courseDetailsReducer,
    courseCreate: courseCreateReducer,
    courseUpdate: courseUpdateReducer,
    courseDelete: courseDeleteReducer,

    holeCreate: holeCreateReducer,
    holeUpdate: holeUpdateReducer,
    holeDelete: holeDeleteReducer,

    tournamentList: tournamentListReducer,
    tournamentDetails: tournamentDetailsReducer,
    tournamentCreate: tournamentCreateReducer,
    tournamentUpdate: tournamentUpdateReducer,
    tournamentDelete: tournamentDeleteReducer,
    tournamentDayCreate: tournamentDayCreateReducer,
    tournamentDayUpdate: tournamentDayUpdateReducer,
    tournamentDayDelete: tournamentDayDeleteReducer,
    tournamentAwardCreate: tournamentAwardCreateReducer,
    tournamentAwardDelete: tournamentAwardDeleteReducer,
    tournamentContestCreate: tournamentContestCreateReducer,
    tournamentContestDelete: tournamentContestDeleteReducer,
    tournamentRegList:   tournamentRegListReducer,
    tournamentRegAdd:    tournamentRegAddReducer,
    tournamentRegUpdate: tournamentRegUpdateReducer,
    tournamentRegDelete: tournamentRegDeleteReducer,
    tournamentTeamsList:       tournamentTeamsListReducer,
    tournamentTeamsGenerate:   tournamentTeamsGenerateReducer,
    tournamentTeamsClear:      tournamentTeamsClearReducer,
    tournamentTeamAdd:         tournamentTeamAddReducer,
    tournamentTeamMemberAdd:   tournamentTeamMemberAddReducer,
    tournamentTeamMemberRemove: tournamentTeamMemberRemoveReducer,
    tournamentAwardUpdate:   tournamentAwardUpdateReducer,
    tournamentContestUpdate: tournamentContestUpdateReducer,
    tournamentWinnerUpdate:  tournamentWinnerUpdateReducer,

    leagueList:             leagueListReducer,
    leagueDetails:          leagueDetailsReducer,
    leagueActive:           leagueActiveReducer,
    leagueCreate:           leagueCreateReducer,
    leagueUpdate:           leagueUpdateReducer,
    leagueDelete:           leagueDeleteReducer,
    leagueRegisterPlayer:   leagueRegisterPlayerReducer,
    leagueRemovePlayer:     leagueRemovePlayerReducer,
    leagueGenerateSchedule: leagueGenerateScheduleReducer,
    leagueMatchupUpdate:    leagueMatchupUpdateReducer,
    leagueMatchupLock:      leagueMatchupLockReducer,
    leagueScores:           leagueScoresReducer,
    leagueSaveScore:        leagueSaveScoreReducer,
})

// local storage logic
// this is to persist cart items in local storage
// it pulls from the users browser local storage
// if nothing there it sets to empty array
const userInfoFromStorage = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : null
const initialState = {
    userLogin: { userInfo: userInfoFromStorage },
}

const middleware = [thunk]

const store = createStore(reducer, initialState, applyMiddleware(...middleware))

export default store